import { render, staticRenderFns } from "./PropostaCancelar.vue?vue&type=template&id=12bcef02"
import script from "./PropostaCancelar.vue?vue&type=script&lang=js"
export * from "./PropostaCancelar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports